export default __webpack_public_path__ + "static/media/save-money_1.789fb3c8.png";